// src/components/StripeSetupForm.js
import React, { useState } from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { IoCardOutline } from 'react-icons/io5';

const CARD_ELEMENT_OPTIONS = {
    style: {
        base: {
            color: '#32325d',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': { color: '#aab7c4' }
        },
        invalid: { color: '#fa755a', iconColor: '#fa755a' }
    },
    hidePostalCode: true,
};

const StripeSetupForm = ({ onSuccess, onCancel, clientSecret }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [errorMessage, setErrorMessage] = useState(null);
    const [processing, setProcessing] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements || !clientSecret) return;

        setProcessing(true);
        setErrorMessage(null);

        const cardElement = elements.getElement(CardElement);

        const { error, setupIntent } = await stripe.confirmCardSetup(clientSecret, {
            payment_method: {
                card: cardElement,
            }
        });

        if (error) {
            setErrorMessage(error.message);
            setProcessing(false);
        } else {
            setProcessing(false);
            if (onSuccess) onSuccess();
        }
    };

    return (
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <div style={{ marginBottom: '20px', padding: '12px', border: '1px solid #cbd5e1', borderRadius: '8px', background: 'white' }}>
                <CardElement options={CARD_ELEMENT_OPTIONS} />
            </div>

            {errorMessage && <div style={{ color: '#ef4444', marginBottom: '15px', fontSize: '0.9rem' }}>{errorMessage}</div>}

            <div style={{ display: 'flex', gap: '10px' }}>
                <button
                    type="button"
                    onClick={onCancel}
                    disabled={processing}
                    className="form-button secondary"
                    style={{ flex: 1, backgroundColor: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' }}
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    disabled={!stripe || processing}
                    className="form-button"
                    style={{ flex: 2, backgroundColor: '#6366f1' }}
                >
                    {processing ? 'Guardando...' : (
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            <IoCardOutline size={20} /> Guardar Tarjeta
                        </span>
                    )}
                </button>
            </div>
            <p style={{ marginTop: '15px', fontSize: '0.8em', color: '#64748b', textAlign: 'center' }}>
                Tus datos están protegidos y procesados de manera segura por Stripe. No almacenamos los datos completos de tu tarjeta.
            </p>
        </form>
    );
};

export default StripeSetupForm;
